import { render, staticRenderFns } from "./CragDescription.vue?vue&type=template&id=5c0b14f1"
import script from "./CragDescription.vue?vue&type=script&lang=js"
export * from "./CragDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports